import { render, staticRenderFns } from "./CashPayway.vue?vue&type=template&id=04651cbb&"
import script from "./CashPayway.vue?vue&type=script&lang=js&"
export * from "./CashPayway.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports